import styled from '@emotion/styled';
import React from 'react';
import { useSelector } from 'react-redux';

import { getGroupSelectNameById } from 'modules/groups/selectors';

const Name = styled.span`
    display: block;
    min-width: 100px;
`;

const Group = ({ id }) => {
  const name = useSelector(state => getGroupSelectNameById(state, id));
  return <Name>{name}</Name>;
};

export default Group;
